import React, { Component } from 'react';
import { connect } from 'react-redux';
import CryptoTransactionsView from './CryptoTransactions.view';

export class CryptoTransactionsContainer extends Component {

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_CRYPTO_TRANSACTIONS_DATA'
    });
  }

  render() {
    return (<CryptoTransactionsView
      {...this.state}
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { cryptoTransactions } = state;
  return {
    ...cryptoTransactions,
  };
}

export default connect(mapStateToProps)(CryptoTransactionsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/CryptoTransactions/CryptoTransactions.container.js